import { FC } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import cn from 'bem-cn';

import { LinkProps } from './Link.types';

import './Link.scss';

const b = cn('link');

export const Link: FC<LinkProps> = ({
    children,
    className = '',
    to,
    onClick,
    preventDefault = false,
    external,
    ref,
    replace = false,
    underlined = false,
    ...props
}) => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (preventDefault) {
            event.preventDefault();
        }

        onClick?.(event);
    };

    const linkClassName = `${b({
        underlined,
    })} ${className}`;

    if (external) {
        return (
            <a
                ref={ref}
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                className={linkClassName}
                onClick={handleClick}
                {...props}
            >
                {children}
                {/* {showExternalIcon && <span className={b('external-icon')}>↗</span>} */}
            </a>
        );
    }

    return (
        <ReactRouterLink ref={ref} to={to} replace={replace} className={linkClassName} onClick={handleClick} {...props}>
            {children}
        </ReactRouterLink>
    );
};
